import { compose } from 'ramda';
import { connect } from 'react-redux';

import { trackElementShown, trackFullscreenLayoutOpen } from './tracking';
import { CianLayout, ICianLayoutProps } from '../../components/CianLayout';
import { IState } from '../../store';
import { withEmptyRendering } from '../../utils/hoc';

export function mapStateToProps(state: IState): ICianLayoutProps {
  const { cianLayouts, id: offerId } = state.offerData.offer;
  const layout = cianLayouts && cianLayouts.length > 0 ? cianLayouts[0] : null;

  return {
    imageUrl: layout?.fullUrl || '',
    onShownInViewport: () => trackElementShown(offerId),
    onFullscreenLayoutOpen: () => trackFullscreenLayoutOpen(offerId),
  };
}

export function shouldHideCianLayout({ imageUrl }: ICianLayoutProps) {
  return !imageUrl;
}

export const CianLayoutContainer = compose(
  connect<ICianLayoutProps>(mapStateToProps),
  withEmptyRendering(shouldHideCianLayout),
)(CianLayout);
